import React from "react";
import classNames from "classnames";
import { Form } from "semantic-ui-react";

export default function FormGroup({
  name,
  error,
  valid = !error,
  label,
  help,
  helpBelow = false,
  required,
  inline,
  multipleFields,
  children,
  className,
  style,
}) {
  return (
    <Form.Field
      error={!valid}
      inline={inline}
      className={classNames({
        fields: inline && multipleFields,
        [classNames(className)]: true,
      })}
      style={style}
    >
      {label && (
        <label htmlFor={name}>
          {label}
          {required && <span> *</span>}
        </label>
      )}
      {!helpBelow && !!help && <div className="ui help">{help}</div>}
      {children}
      {!!error && (
        <div className="ui help error">
          {error} <i className="icon material-icons">error_outline</i>
        </div>
      )}
      {helpBelow && !!help && <div className="ui help">{help}</div>}
    </Form.Field>
  );
}



// WEBPACK FOOTER //
// ./src/lib/components/FormControl/FormGroup.jsx